import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ContainerRefDirective } from '@common/directives';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/common.service';
import { IServiceRequest, IServiceRequestStage } from 'src/app/common/models/service-request.model';
import { PopupItem } from 'src/app/common/services/popup/popup-item';
import { PopupService } from 'src/app/common/services/popup/popup.service';
import { RetailStock } from 'src/app/retail-common.service';
import { ServiceStock } from 'src/app/service-stock.service';
import { ServiceRequestHistoryService } from 'src/app/services/service-request-history/service-request-history.service';
import { RepaymentScheduleComponent } from '../../loans/repayment-schedule/repayment-schedule.component';

@Component({
  selector: 'app-service-request-tracker',
  templateUrl: './service-request-tracker.component.html',
  styleUrls: ['./service-request-tracker.component.scss']
})
export class ServiceRequestTrackerComponent implements OnInit, AfterViewInit, OnDestroy{
  @ViewChild(ContainerRefDirective, {static: true}) containerRef!: ContainerRefDirective;

  tabToShow:string = 'allTransactions';

  settingsTabList:any = [
    { id: "status", text: this.translate.instant('SERVICEREQUESTLANDING.status') },
    { id: "request", text: this.translate.instant('SERVICEREQUESTLANDING.request') }
  ];
  cardDetails: IServiceRequest;
  serviceRequestStages: IServiceRequestStage[];
  requestReference: any;
  popupItem: PopupItem;
  paymentSystem: any;
  // data: any;

  constructor(private _router: Router,
    private services: ServiceStock,
    private _retailStock:RetailStock,
    private _serviceRequestHistoryService: ServiceRequestHistoryService,
    private _popupService: PopupService,
    public dialogRef: MatDialogRef<ServiceRequestTrackerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected _commonService: CommonService,
    protected translate: TranslateService
  ) {
    if(this._commonService.isMobile())
    this.requestReference = this._router.getCurrentNavigation()?.extras?.queryParams?.requestReference;
    this._serviceRequestHistoryService.setTrackerDetails(this._router.getCurrentNavigation()?.extras?.queryParams);
  }
  ngOnInit(): void {
    document.body.classList.add('app-service-request-tracker');
    if(!this.requestReference && this._commonService.isDesktop()) {
      this.requestReference = this.data.screenData.requestReference;
      this._serviceRequestHistoryService.setTrackerDetails(this.data.screenData);
      let component = this._popupService.getPopup(this.data.screenData.requestType);
      this.popupItem = component;
    }
    this._retailStock.headerRequired = false;
    this._retailStock.headerRequired = false;
    this.cardDetails = this._serviceRequestHistoryService.getServiceRequestItem(this.requestReference)
    
    this._serviceRequestHistoryService.fetchServiceReqStages(this.cardDetails.requestReference).subscribe(
      (res)=> {
        this.serviceRequestStages = res;
      }
    )
  }
  ngAfterViewInit(){
    if(this._commonService.isDesktop()) this.loadComponent();
  }

  loadComponent() {
    const popup = this.popupItem;

    const viewContainerRef = this.containerRef.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent<any>(popup.component);
    componentRef.instance.data = this.data;
  }

  onSelectTab(tabId:string){
    this.tabToShow = tabId;
  }

  ngOnDestroy() {
    this._retailStock.headerRequired = true;
    this._retailStock.headerRequired = true;
    this._retailStock.backBtnUrl = undefined;
    document.body.classList.remove('app-service-request-tracker');
    this._serviceRequestHistoryService.resetTrackerDetails();
  }

  gotoLanding() {
    this._router.navigate(['home','service-requests']);
  }



}
